import React, { useEffect } from 'react';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';
import useTrialProtectedPageGuard from 'components/Trials/hooks/useTrialProtectedPageGuard';
import RoiModal from '../RoiModal';
import AccountVerificationContent from './AccountVerificationContent';
import ProfileImagery from '../Profile/imagery';

const AccountVerification = () => {
  useTrialProtectedPageGuard();

  const trackEvent = useTrackAmplitudeEvent();
  useEffect(() => {
    trackEvent('trials.accountVerification.verificationPageViewed');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RoiModal progress={33}>
      <AccountVerificationContent />
      <ProfileImagery disableAnimations={true} />
    </RoiModal>
  );
};

export default AccountVerification;
